import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

export const aiInsightsService = {
  async createCallReportDataset(filters, scope, snapshotKey) {
    try {
      const resp = await fetch(`${SUPABASE_URL}/functions/v1/call-report-ai-dataset`, {
        method: 'POST',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ filters, scope, snapshotKey }),
      });
      const body = await resp.json().catch(() => ({}));
      if (!resp.ok || !body?.success) {
        throw new Error(body?.error || `Dataset create failed: ${resp.status}`);
      }
      return { success: true, datasetId: body.datasetId };
    } catch (e) {
      return { success: false, error: e?.message || String(e) };
    }
  },

  async chatCallReportInsights(messages, datasetId) {
    try {
      const resp = await fetch(`${SUPABASE_URL}/functions/v1/call-report-ai-chat`, {
        method: 'POST',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ datasetId, messages }),
      });
      const body = await resp.json().catch(() => ({}));
      if (!resp.ok || !body?.success) {
        throw new Error(body?.error || `Chat failed: ${resp.status}`);
      }
      return { success: true, answer: body.answer || '' };
    } catch (e) {
      return { success: false, error: e?.message || String(e) };
    }
  },
};


